import React from "react";
import styles from "./MeetingAttendee.module.css";
import { USER_ROLES } from "./UserProvider";

const MeetingAttendee = ({ guest, displayAttendeeDetails }) => {
  return (
    <div className="media">
      <div className={`mr-3 ${styles.mediaImage}`}>
        <img
          //src={`https://picsum.photos/128?random=${guest.ProfileID}`}
          src={`${guest.Profile.ProfilePhotoFullPath}`}
          className="rounded-lg bg-light"
          width="64"
          height="64"
          alt={guest.NameOnBadge}
        />
      </div>
      <div className="media-body">
        <h5 className={`${styles.attendeeName} mt-0 mb-1`}>
          <span>
            {guest.Profile.FirstName} {guest.Profile.LastName}
          </span>
          {(guest.Role === USER_ROLES.HOST ||
            guest.Role === USER_ROLES.ADMIN) && (
            <span
              className={`badge badge-pill badge-primary ml-2 ${styles.hostBadge}`}
            >
              Host
            </span>
          )}
          {guest.Role === USER_ROLES.RECEPTIONIST && (
            <span
              className={`badge badge-pill badge-primary ml-2 ${styles.hostBadge}`}
            >
              Reception
            </span>
          )}
        </h5>
        <p className={`${styles.attendeeTitle} font-weight-normal m-0 p-0`}>
          {guest.Title ?? guest.Profile.Title}
        </p>
        {(guest.CompanyProfile || guest.Profile.Company) && (
          <p className={`${styles.attendeeCompany} font-weight-bold m-0 p-0`}>
            {guest.CompanyProfile
              ? guest.CompanyProfile.CompanyName
              : guest.Profile.Company}
          </p>
        )}
      </div>
    </div>
  );
};

export default MeetingAttendee;
